<app-header></app-header>
<app-nav-menu></app-nav-menu>
<main id="main" class="main">

  <div class="pagetitle">
    <h1>Manage Sites</h1>
    <nav>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/']">Home</a></li>
        <li class="breadcrumb-item active">Manage Sites</li>
      </ol>
    </nav>
  </div>

  <section class="section dashboard">
    <div class="container bg-white overflow-auto min-height">
      <div>
        <button type="button" class="btn btn-warning mt-3 btn-sm" [routerLink]="['/pricing']"><i class="bi bi-star-fill me-1"></i> Upgrade Plan</button> &nbsp;
        <button type="button" class="btn btn-info mt-3 btn-sm"  data-bs-toggle="modal" data-bs-target="#howAutoIndexingWorksModal"><i class="bi bi-question-circle-fill me-1"></i> How Auto Indexing Works?</button> &nbsp;
        <button type="button" class="btn btn-primary mt-3 btn-sm" (click)="getSitesFromGapi()"><i class="bi bi-bootstrap-reboot me-1"></i> Refetch Sites</button> &nbsp;
        <button type="button" class="btn btn-primary mt-3 btn-sm" (click)="getGscAccess(true)"><i class="bi bi-bootstrap-reboot me-1"></i> Recheck All Grants</button>
      </div>
      <hr />
      <app-spinner *ngIf="showSpinner" loadingText="Fetching websites. This may take some time..."></app-spinner>
      <!-- Table with hoverable rows -->
      <table class="table table-hover" *ngIf="!showSpinner">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Property</th>
            <th scope="col">Enabled ({{enabledSiteCount}}/{{userPlan.enabledSiteCount}})</th>
            <th scope="col">Grant Access</th>
            <th scope="col">Auto Indexing</th>
            <th scope="col">Limit <span class="bi bi-info-circle-fill tooltip-custom"><span class="tooltiptext">Daily quota limit for auto-indexing.<br /> We will stop auto-indexing once we reach your daily limit.</span>  </span></th>
            <th scope="col">History</th>
            <th scope="col">Submit Urls</th>
            <th scope="col">Check SEO</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-center" *ngIf="sites.length==0">
            <td colspan="8">No records found.</td>
          </tr>
          <tr *ngFor="let site of sites">
            <td>
              <input type="hidden" [(ngModel)]="site.id" />
              <img *ngIf="site.favIconUrl!=null" src="resources/SiteFavicons/{{site.favIconUrl}}" alt="site logo" class="rounded-circle" width="20" height="20">
              <i *ngIf="site.favIconUrl==null" class="bi bi-browser-chrome text-secondary"></i>
            </td>
            <td>
              {{site.url | replace : 'sc-domain:' : '' | replace : 'http://' : '' | replace : 'https://' : '' | replace : 'www.' : ''}}
              <br />
              <span class="badge rounded-pill bg-success" *ngIf="site.permissionLevel=='Owner'">{{site.permissionLevel}}</span>
              <span class="badge rounded-pill bg-danger" *ngIf="site.permissionLevel!='Owner'">{{site.permissionLevel}} <span class="bi bi-info-circle-fill tooltip-custom"><span class="tooltiptext">You need full owner permission <br />to start indexing for this site.</span>  </span></span>
            </td>

            <td>
              <div class="form-check form-switch marginLeft15">
                <input class="form-check-input" type="checkbox" [(ngModel)]="site.isEnabled" (change)="updateSite(site,0)" *ngIf="userPlan.allowedIndexingQuota!=0">
                <input class="form-check-input" type="checkbox" (change)="setSiteDisabled($event)" *ngIf="userPlan.allowedIndexingQuota==0" data-bs-toggle="modal" data-bs-target="#upgradeModal">
              </div>
            </td>
            <td>
              <app-spinner *ngIf="userPlan.allowedIndexingQuota!=0 && site.isEnabled && showGrantAccessSpinner"></app-spinner>
              <button [ngClass]="{'disabled':  serviceAccounts.length==0}" type="button" class="btn btn-warning btn-sm" data-bs-toggle="modal" data-bs-target="#accessModal" *ngIf="userPlan.allowedIndexingQuota!=0 && site.isEnabled && !site.isAccessGranted && !showGrantAccessSpinner">Grant Access <i class="bi bi-exclamation-triangle"></i></button>
              <button [ngClass]="{'disabled':  serviceAccounts.length==0}" type="button" class="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target="#accessModal" *ngIf="userPlan.allowedIndexingQuota!=0 && site.isEnabled  && site.isAccessGranted && !showGrantAccessSpinner">Grant Access <i class="bi bi-check-circle"></i></button>
            </td>
            <td>
              <div class="form-check form-switch marginLeft15" *ngIf="site.isEnabled && serviceAccounts.length>0 && userPlan.allowedIndexingQuota!=0 && site.isAccessGranted">
                <input [disabled]="!site.isEnabled" class="form-check-input" type="checkbox" [(ngModel)]="site.isAutoIndexingEnabled" (change)="updateSite(site,1)">
                <i class="bi bi-gear h5" *ngIf="site.isAutoIndexingEnabled" data-bs-toggle="modal" data-bs-target="#sitemapModal" (click)="setAutoIndexTypeForSelectedSite(site)"></i>
              </div>
            </td>
            <td>
              <input type="number" [disabled]="!site.isAutoIndexingEnabled" *ngIf="site.isEnabled && serviceAccounts.length>0 && userPlan.allowedIndexingQuota!=0 && site.isAccessGranted" class="form-control input-dailyQuotaLimit" placeholder="Daily Quota Limit" name="dailyQuotaLimit" [(ngModel)]="site.dailyQuotaLimit" (change)="dailyQuotaLimitChange(site.id,site.dailyQuotaLimit)">
            </td>
            <td>
              <button *ngIf="site.isEnabled && serviceAccounts.length>0 && userPlan.allowedIndexingQuota!=0 && site.isAccessGranted" type="button" class="btn btn-primary btn-sm marginLeft15" [routerLink]="['/indexing-history']" [queryParams]="{siteId: site.id}"><i class="bi bi-search"></i></button>
            </td>
            <td>
              <button *ngIf="site.isEnabled && serviceAccounts.length>0 && userPlan.allowedIndexingQuota!=0 && site.isAccessGranted" type="button" class="btn btn-primary btn-sm marginLeft15" data-bs-toggle="modal" data-bs-target="#submitUrlModal" (click)="setClickedSiteId(site.id)"><i class="bi bi-send"></i></button>
            </td>
            <td>
              <button *ngIf="site.isEnabled && serviceAccounts.length>0 && userPlan.allowedIndexingQuota!=0 && site.isAccessGranted" type="button" class="btn btn-primary btn-sm marginLeft15" data-bs-toggle="modal" data-bs-target="#checkSeoModal" (click)="checkSeo(site.url)"><i class="bi bi-activity"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- End Table with hoverable rows -->
    </div>

    <app-generic-modal modalTitle="Configure Auto Indexing" modalId="sitemapModal" modalSize="modal-lg">
      <div>
        <div class="row w-50 m-0 m-auto">
          <div class="form-check col">
            <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios2" [value]="0" [(ngModel)]="autoIndexType" (change)="onAutoIndexTypeChanged()">
            <label class="form-check-label" for="gridRadios2">
              Auto Index By Bulk URL Submission
            </label>
          </div>

          <div class="form-check col">
            <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios1" [value]="1" [(ngModel)]="autoIndexType" checked="" (change)="onAutoIndexTypeChanged()">
            <label class="form-check-label" for="gridRadios1">
              Auto Index By Sitemaps
            </label>
          </div>
        </div>
      </div>
      <hr />
      <div *ngIf="autoIndexType==0">
        <div class="alert alert-primary show mt-3" role="alert">
          <i class="bi bi-star me-1"></i>
          Please add URLs to the queue that you want to be indexed automatically. Our queue will be checked daily, and we will submit URLs from the queue for indexing within the range of your allowed quota in your plan.
        </div>
        <label class="col-sm-2 col-form-label"><b>Enter Urls:</b></label>
        <textarea class="form-control" [(ngModel)]="autoIndexUrls" style="height: 200px" placeholder="Enter URLs, separated by commas or lines" (ngModelChange)="autoIndexUrlsChanged()"></textarea>
        <span class="float-end badge rounded-pill bg-primary mt-2">Total: {{autoIndexUrlsSplittedCount}} URLs</span>

        <div class="alert alert-info alert-dismissible fade show mt-5" role="alert">
          <i class="bi bi-info"></i>Max <u>1000 Urls</u> at a time. Separate URLs by commas or new lines. Be sure to include <u>http or https</u>.
        </div>

        <button class="btn btn-primary float-end" *ngIf="!showIndexingSpinner" (click)="addUrlsToQueue()">Add to Queue</button>
        <app-spinner *ngIf="showAutoIndexingQueueSpinner" class="float-end" loadingText="Adding URLs to Auto Indexing Queue..."></app-spinner>
      </div>

      <div *ngIf="autoIndexType==1">
        <div class="alert alert-primary show mt-3" role="alert">
          <i class="bi bi-star me-1"></i>
          Enable sitemaps that you want to be indexed automatically. We will check each sitemap and automatically add URLs to queue. Our queue will be checked daily, and we will submit URLs from the queue for indexing within the range of your allowed quota in your plan.
        </div>
        <div class="alert alert-warning show mt-3" role="alert">
          <i class="bi bi-info-circle me-1"></i>
          If there are no valid URLs in your sitemaps, we won't be able to auto index. In this case you can use 'Auto Index By Bulk URL Submission' option.
        </div>
        <button type="button" class="btn btn-primary btn-sm" (click)="getSitemapsFromGapi(selectedSiteUrl, selectedSiteId)"><i class="bi bi-bootstrap-reboot"></i> Refetch Sitemaps</button>
        <hr />
        <app-spinner *ngIf="showSitemapSpinner" loadingText="Fetching and Validating Sitemaps. This might take some time if you have many pages..."></app-spinner>
        <div>
          <table class="table table-striped" *ngIf="!showSitemapSpinner">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Sitemap Url</th>
                <th scope="col">Valid Urls</th>
                <th scope="col">Enabled</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" *ngIf="sitemaps.length==0">
                <td colspan="4">No records found.</td>
              </tr>
              <tr *ngFor="let sitemap of sitemaps; index as i">
                <td scope="row">{{i+1}}</td>
                <td>{{sitemap.url}}</td>
                <td>{{sitemap.submittedUrls}} <span *ngIf="sitemap.submittedUrls==null || sitemap.submittedUrls==0" class="bi bi-exclamation-circle-fill text-danger tooltip-custom"><span class="tooltiptext tooltip-sitemap-modal">We are unable to validate URLs. <br />This may be due to the format of your sitemap,<br /> or your hosting provider may not allow us.</span>  </span></td>
                <td>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="sitemapEnabled" [(ngModel)]="sitemap.isEnabled" (change)="updateSitemap(sitemap)" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </app-generic-modal>

    <app-generic-modal modalTitle="Submit Urls" modalId="submitUrlModal">
      <label class="col-sm-2 col-form-label"><b>Enter Urls:</b></label>
      <textarea class="form-control" [(ngModel)]="urls" style="height: 200px" placeholder="Enter URLs, separated by commas or lines" (ngModelChange)="urlsChanged()"></textarea>
      <span class="float-end badge rounded-pill bg-primary mt-2">Total: {{urlsSplittedCount}} URLs</span>

      <div class="alert alert-info alert-dismissible fade show mt-5" role="alert">
        <i class="bi bi-info"></i>Max <u>100 Urls</u> at a time. Separate URLs by commas or new lines. Be sure to include <u>http or https</u>.
      </div>

      <button class="btn btn-primary float-end" *ngIf="!showIndexingSpinner" (click)="indexUrls()">Submit</button>
      <app-spinner *ngIf="showIndexingSpinner" class="float-end" loadingText="Indexing URLs..."></app-spinner>
    </app-generic-modal>

    <app-generic-modal modalTitle="Upgrade Plan" modalId="upgradeModal">
      <p>Upgrade your plan to enable sites and start indexing.</p>

      <div class="float-end">
        <button type="button" class="btn btn-secondary m-1" data-bs-dismiss="modal">Close</button>
        <a class="btn btn-primary" (click)="upgradePlan()">Upgrade</a>
      </div>
    </app-generic-modal>

    <app-generic-modal modalTitle="How Auto Indexing Works?" modalId="howAutoIndexingWorksModal">
      <p>There are 2 types of Auto Indexing which you can choose when you configure Auto Indexing:</p>
      <ul>
        <li>Auto Index By Bulk URL Submission</li>
        <li>Auto Index By Sitemaps</li>
      </ul>
      <h4>Auto Index By Bulk URL Submission</h4>
      <p>When you choose this option, you can submit multiple URLs and those URLs will be added to Auto Index Queue. </p>
      <p>At this time, those URLs are only added to the queue and have not yet been submitted for indexing. Every day, at regular intervals, we will check the queue and submit URLs from the queue for indexing within the range of your allowed quota in your plan.</p>
      <p>You can see the queue processing timetable below.</p>
      <h4>Auto Index By Sitemaps</h4>
      <p>When you choose this option, we will fetch your sitemaps and validate URLs on your sitemaps. You can enable or disable each sitemap. We will check each enabled sitemap and automatically add non-indexed URLs to Auto Index Queue. </p>
      <p>At this time, those URLs are only added to the queue and have not yet been submitted for indexing. Every day, at regular intervals, we will check the queue and submit URLs from the queue for indexing within the range of your allowed quota in your plan.</p>
      <p>You can see the queue processing timetable below.</p>
      <h4>Submission Time for Indexing</h4>
      <p>We will submit URLs for indexing from queue every day at <b>01:00 Pacific Standard Time</b>.</p>
      <h4>Sitemap Checking Times to Add Urls to Auto Index Queue</h4>
      <p>If you choose the "Auto Index By Sitemaps" option, we will check your sitemaps and add URLs from your sitemap to the Auto Index Queue at the following times:</p>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Hour</th>

          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">1</th>
            <td>03:00 Pacific Standard Time</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>06:00 Pacific Standard Time</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>09:00 Pacific Standard Time</td>
          </tr>

        </tbody>
      </table>
      <div class="float-end">
        <button type="button" class="btn btn-secondary m-1" data-bs-dismiss="modal">Close</button>

      </div>
    </app-generic-modal>


    <app-generic-modal modalTitle="Grant Access to Google Search Console" modalId="accessModal">
      <app-spinner *ngIf="showServiceAccountModalSpinner" loadingText="Creating access details. It may take a little while..."></app-spinner>
      <div *ngIf="!showServiceAccountModalSpinner">
        <div class="alert alert-info alert-dismissible fade show" role="alert">
          Add the user below to Google Search Console Users with <b>Owner</b> permission to activate your quota. Each account can submit 200 URLs per day. Click <a href="https://search.google.com/search-console" target="_blank"><u class="fw-bold">here</u></a> to add a new account to your search console account.
        </div>
        <div class="">

          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Email</th>
                <th scope="col">Quota Left</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" *ngIf="serviceAccounts.length==0">
                <td colspan="2">No emails found.</td>
              </tr>
              <tr *ngFor="let serviceAccount of serviceAccounts">
                <td>
                  <button type="button" class="btn btn-secondary" (click)="copyTextToClipboard(serviceAccount.email)"><i class="bi bi-copy me-1"></i> {{serviceAccount.email}}</button>
                </td>
                <td>{{serviceAccount.remainingDailyQuota}}</td>
              </tr>
            </tbody>
          </table>

          <button type="button" class="btn btn-primary mt-3 btn-sm float-end" (click)="getGscAccess(true)" data-bs-dismiss="modal">Verify Grants</button>

        </div>
      </div>
    </app-generic-modal>

    <app-generic-modal modalTitle="SEO Results" modalId="checkSeoModal" modalSize="modal-xl">
      <app-spinner *ngIf="showCheckSeoModalSpinner"></app-spinner>
      <div *ngIf="!showCheckSeoModalSpinner">
        <div *ngIf="seoResults==null">
          <p>No results found.</p>
        </div>
        <div class="row border-bottom-solid" *ngIf="seoResults!=null">
          <div class="col-lg-4">
            <h5>
              <i *ngIf="seoResults.title!=null && (seoResults.title.length>49 && seoResults.title.length<61)" class="bi bi-check-circle-fill text-success"></i>
              <i *ngIf="seoResults.title==null" class="bi bi-x-circle-fill text-danger"></i>
              <i *ngIf="seoResults.title!=null && (seoResults.title.length<50 || seoResults.title.length>60)" class="bi bi-exclamation-circle-fill text-warning"></i>
              Title Test
            </h5>
          </div>
          <div class="col-lg-8">
            <span *ngIf="seoResults.title!=null">
              Title found.
              <span *ngIf="seoResults.title.length<50 || seoResults.title.length>60">Make sure your titles are well-written and interesting, keeping them between 50 and 60 characters.</span>
            </span>
            <span *ngIf="seoResults.title==null">Title not found.</span>

            <div class="alert alert-info show mt-2" role="alert" *ngIf="seoResults.title!=null">

              <b>Title:</b> {{seoResults.title}} <br />
              <b>Length:</b> {{seoResults.title.length}}
            </div>
          </div>
        </div>

        <div class="row mt-2" *ngIf="seoResults!=null">
          <div class="col-lg-4">
            <h5>
              <i *ngIf="seoResults.metaDescription!=null && (seoResults.metaDescription.length>149 && seoResults.metaDescription.length<221)" class="bi bi-check-circle-fill text-success"></i>
              <i *ngIf="seoResults.metaDescription==null" class="bi bi-x-circle-fill text-danger"></i>
              <i *ngIf="seoResults.metaDescription!=null && (seoResults.metaDescription.length<150 || seoResults.metaDescription.length>220)" class="bi bi-exclamation-circle-fill text-warning"></i>
              Meta Description Test
            </h5>
          </div>
          <div class="col-lg-8">
            <span *ngIf="seoResults.metaDescription!=null">
              Meta description found.
              <span *ngIf="seoResults.metaDescription.length<150 || seoResults.metaDescription.length>220">Make sure your meta descriptions are well-written and interesting, keeping them between 150 and 220 characters.</span>
            </span>
            <span *ngIf="seoResults.metaDescription==null">Meta description not found.</span>

            <div class="alert alert-info show mt-2" role="alert" *ngIf="seoResults.metaDescription!=null">

              <b>Meta Description:</b> {{seoResults.metaDescription}} <br />
              <b>Length:</b> {{seoResults.metaDescription.length}}
            </div>
          </div>
        </div>

        <div class="row mt-2" *ngIf="seoResults!=null">
          <div class="col-lg-4">
            <h5>
              <i *ngIf="seoResults.openGraphMetaTags!=null && seoResults.openGraphMetaTags.length>0" class="bi bi-check-circle-fill text-success"></i>
              <i *ngIf="seoResults.openGraphMetaTags==null ||  seoResults.openGraphMetaTags.length==0" class="bi bi-x-circle-fill text-danger"></i>
              Social Media Meta Tags Test
            </h5>
          </div>
          <div class="col-lg-8">
            <b *ngIf="seoResults.openGraphMetaTags!=null && seoResults.openGraphMetaTags.length>0">
              Open graph meta tags found.
            </b>
            <b *ngIf="seoResults.openGraphMetaTags==null || seoResults.openGraphMetaTags.length==0">Open graph meta tags not found.</b>

            <table class="table table-bordered mt-2" *ngIf="seoResults.openGraphMetaTags!=null && seoResults.openGraphMetaTags.length>0">
              <tbody>
                <tr *ngFor="let openGraphMetaTag of seoResults.openGraphMetaTags">
                  <td>{{openGraphMetaTag.key}}</td>
                  <td>{{openGraphMetaTag.value}}</td>
                </tr>
              </tbody>
            </table>
            <br />
            <b *ngIf="seoResults.twitterGraphMetaTags!=null && seoResults.twitterGraphMetaTags.length>0">
              Twitter card meta tags found.
            </b>
            <b *ngIf="seoResults.twitterGraphMetaTags==null || seoResults.twitterGraphMetaTags.length==0">Twitter card meta tags not found.</b>
            <br />
            <table class="table table-bordered mt-2" *ngIf="seoResults.twitterGraphMetaTags!=null  && seoResults.twitterGraphMetaTags.length>0">
              <tbody>
                <tr *ngFor="let twitterGraphMetaTag of seoResults.twitterGraphMetaTags">
                  <td>{{twitterGraphMetaTag.key}}</td>
                  <td>{{twitterGraphMetaTag.value}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row mt-2" *ngIf="seoResults!=null">
          <div class="col-lg-4">
            <h5>
              <i *ngIf="(seoResults.h1Headings==null && seoResults.h2Headings!=null) || (seoResults.h1Headings!=null && seoResults.h2Headings==null)" class="bi bi-exclamation-circle-fill text-warning"></i>
              <i *ngIf="seoResults.h1Headings!=null  && seoResults.h2Headings!=null" class="bi bi-check-circle-fill text-success"></i>
              <i *ngIf="seoResults.h1Headings==null && seoResults.h2Headings==null " class="bi bi-x-circle-fill text-danger"></i>
              Heading Tags Test
            </h5>
          </div>
          <div class="col-lg-8">
            <b *ngIf="seoResults.h1Headings!=null && seoResults.h1Headings.length>0">
              H1 Heading tags found.
            </b>
            <b *ngIf="seoResults.h1Headings==null || seoResults.h1Headings.length==0">H1 heading tags not found.</b>

            <table class="table table-bordered mt-2" *ngIf="seoResults.h1Headings!=null && seoResults.h1Headings.length>0">
              <tbody>
                <tr *ngFor="let heading of seoResults.h1Headings">
                  <td>{{heading}}</td>
                </tr>
              </tbody>
            </table>
            <br />
            <b *ngIf="seoResults.h2Headings!=null && seoResults.h2Headings.length>0">
              H2 Heading tags found.
            </b>
            <b *ngIf="seoResults.h2Headings==null || seoResults.h2Headings.length==0">H2 heading tags not found.</b>

            <table class="table table-bordered mt-2" *ngIf="seoResults.h2Headings!=null && seoResults.h2Headings.length>0">
              <tbody>
                <tr *ngFor="let heading of seoResults.h2Headings">
                  <td>{{heading}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </app-generic-modal>

    <app-alert [showMessage]="showMessage" [message]="message" [alertType]="alertType">
    </app-alert>
  </section>
</main>

<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
